'use client';

import { FONT_TEXT } from '@/app/fonts';
import { ShareableChart } from '@/components/blog/ShareableChart';

const quarters = [
  {
    label: 'Q1',
    months: [
      { month: 'Month 1', test: 'Headline & CTA copy', area: 'Landing pages', color: '#ff34a7' },
      { month: 'Month 2', test: 'Form length & steps', area: 'Lead capture', color: '#ff34a7' },
      { month: 'Month 3', test: 'Ad creative & targeting', area: 'Paid channels', color: '#294bfd' },
    ]
  },
  {
    label: 'Q2',
    months: [
      { month: 'Month 4', test: 'Calculator vs form (homepage)', area: 'Website', color: '#294bfd' },
      { month: 'Month 5', test: 'Email subject lines & send times', area: 'Database', color: '#10b981' },
      { month: 'Month 6', test: 'Social proof placement', area: 'Trust signals', color: '#ff34a7' },
    ]
  },
  {
    label: 'Q3',
    months: [
      { month: 'Month 7', test: 'Landing page layout', area: 'Conversion', color: '#ff34a7' },
      { month: 'Month 8', test: 'Follow-up sequence timing', area: 'Speed-to-lead', color: '#294bfd' },
      { month: 'Month 9', test: 'Content types & topics', area: 'SEO / Blog', color: '#10b981' },
    ]
  },
  {
    label: 'Q4',
    months: [
      { month: 'Month 10', test: 'Retargeting creative', area: 'Paid', color: '#294bfd' },
      { month: 'Month 11', test: 'Referral partner outreach', area: 'Partnerships', color: '#10b981' },
      { month: 'Month 12', test: 'Full funnel review & next year\'s plan', area: 'Strategy', color: '#ff34a7' },
    ]
  },
];

export function TestingCalendar() {
  return (
    <ShareableChart title="12-Month Mortgage Marketing Testing Roadmap">
      <h3 className="text-lg font-bold text-gray-900 mb-1" style={{ fontFamily: FONT_TEXT }}>
        12-Month Testing Roadmap
      </h3>
      <p className="text-sm text-gray-500 mb-6" style={{ fontFamily: FONT_TEXT }}>
        One focused test per month. Compound improvements add up fast.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {quarters.map((q) => (
          <div key={q.label} className="rounded-lg border border-gray-200 p-4">
            <h4 className="font-bold text-gray-900 mb-3 text-sm" style={{ fontFamily: FONT_TEXT }}>
              {q.label}
            </h4>
            <div className="space-y-2.5">
              {q.months.map((m) => (
                <div key={m.month} className="flex items-start gap-2">
                  <div className="w-2 h-2 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: m.color }} />
                  <div>
                    <div className="text-sm font-medium text-gray-900" style={{ fontFamily: FONT_TEXT }}>
                      {m.month}: {m.test}
                    </div>
                    <div className="text-xs text-gray-400" style={{ fontFamily: FONT_TEXT }}>
                      {m.area}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 p-3 rounded-lg border-l-4" style={{ borderColor: '#ff34a7', backgroundColor: '#fff5fb' }}>
        <p className="text-sm text-gray-700" style={{ fontFamily: FONT_TEXT }}>
          <strong>The rule:</strong> Test one thing at a time. Run each test for 2-4 weeks minimum. Document everything. What converts in Phoenix might bomb in Philadelphia.
        </p>
      </div>

      <p className="text-xs text-gray-400 mt-3" style={{ fontFamily: FONT_TEXT }}>
        Source: leadpops.com · Adapt this roadmap to your specific market and current performance gaps
      </p>
    </ShareableChart>
  );
}
